import React, { forwardRef } from "react"

import { useField, useFormikContext } from "formik"

import ErrorMessage from "./ErrorMessage"

const FileField = forwardRef((props: any, ref) => {
  const [field, meta] = useField(props)
  const { setFieldValue } = useFormikContext()

  // exclude onChange and value field props
  const { onChange, value, ...fieldProps } = field

  return (
    <div className="form-group">
      <label className="form-label w-100">
        <span>{props?.label}</span>
        <input
          type="file"
          className="form-control"
          onChange={e => setFieldValue(props?.name, e.currentTarget.files[0])}
          ref={ref}
          {...fieldProps}
          {...props}
        />
        <ErrorMessage {...meta} />
      </label>
    </div>
  )
})

export default FileField
